function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76,
    xmlns: "http://www.w3.org/2000/svg",
    height: 76,
    id: "screenshot-f293a4cf-8081-8014-8003-5f7f468c6fc0",
    viewBox: "0 0 76 76",
    style: {
      WebkitPrintColorAdjust: "exact"
    },
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-f293a4cf-8081-8014-8003-5f7f468c6fc0",
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-f293a4cf-8081-8014-8003-5f7e87b95a4c"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-f293a4cf-8081-8014-8003-5f7e87b95a4c"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 38,
    ry: 38,
    cx: 38,
    cy: 38,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "rgb(54, 159, 255)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-f293a4cf-8081-8014-8003-5f7ed87dc162"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-f293a4cf-8081-8014-8003-5f7ed87dc162"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 33.50000000000091,
    y: 22.5,
    transform: "matrix(-0.000000, 1.000000, -1.000000, -0.000000, 75.500000, 2.500000)",
    width: 5.999999999999545,
    height: 33,
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-f293a4cf-8081-8014-8003-5f7ef3f223a6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-f293a4cf-8081-8014-8003-5f7ef3f223a6"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 42.96015510839152,
    y: 33.46015510839152,
    transform: "matrix(0.707107, 0.707107, -0.707107, 0.707107, 45.960155, -19.037320)",
    width: 5.9999999999990905,
    height: 25,
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-f293a4cf-8081-8014-8003-5f7efac65167"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-f293a4cf-8081-8014-8003-5f7efac65167"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    x: 41.84124903175393,
    y: 18.57572261560972,
    transform: "matrix(-0.719340, 0.694658, -0.694658, -0.719340, 98.684355, 22.280378)",
    width: 5.9999999999990905,
    height: 25,
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowButton);
export default __webpack_public_path__ + "static/media/arrow-button.db2f9e82f55b3341b24329370719a91d.svg";
export { ForwardRef as ReactComponent };